/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import PropTypes from "prop-types";
import ActionButton from "./ActionButton";
import BenefitSearch from '../../../assets/logos/benefit-search-icn.svg';
import SaveBtnBox from '../../../assets/logos/save-btn-chatbox.svg';
import FeedbackToggle from './FeedbackToggle';

const SuggestedActions = ({
  applicationCount,
  onRunDuplicateCheck,
  onSaveForLater,
  runDuplicateLabel,
  saveLaterLabel,
  showViewReportButton = false,
  disabled = false,
  userId,
  agentName,
  threadId,
  ratedMessage,
  messageIndex,
  chatHistory,
  userPrompt,
  showFeedback = true,
}) => {
  const shouldShowActionButtons = Boolean(showViewReportButton);
  const shouldShowFeedback = Boolean(showFeedback);

  if (!shouldShowActionButtons && !shouldShowFeedback) {
    return null;
  }

  return (
    <div className={`suggested-actions${shouldShowActionButtons ? "" : " feedback-only-actions"}`}>
      {shouldShowActionButtons && <h4>SUGGESTED ACTIONS</h4>}

      <div className="action-wrapper">
        {shouldShowActionButtons && (
          <ActionButton
            label={runDuplicateLabel || `Run duplicate check on all ${applicationCount} applications`}
            onClick={onRunDuplicateCheck}
            btnImage={BenefitSearch}
            disabled={disabled}
          />
        )}

        {shouldShowActionButtons && saveLaterLabel && (
          <ActionButton
            label={saveLaterLabel || "Save it for later"}
            onClick={onSaveForLater}
            btnImage={SaveBtnBox}
          />
        )}

        {shouldShowFeedback && (
          <FeedbackToggle
            userId={userId}
            agentName={agentName}
            threadId={threadId}
            ratedMessage={ratedMessage}
            messageIndex={messageIndex}
            chatHistory={chatHistory}
            userPrompt={userPrompt}
          />
        )}
      </div>
    </div>
  );
};

export default SuggestedActions;

SuggestedActions.propTypes = {
  applicationCount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onRunDuplicateCheck: PropTypes.func,
  onSaveForLater: PropTypes.func,
  runDuplicateLabel: PropTypes.string,
  saveLaterLabel: PropTypes.string,
  showViewReportButton: PropTypes.bool,
  disabled: PropTypes.bool,
  userId: PropTypes.string,
  agentName: PropTypes.string,
  threadId: PropTypes.string,
  ratedMessage: PropTypes.string,
  messageIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  chatHistory: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object]),
  userPrompt: PropTypes.string,
  showFeedback: PropTypes.bool,
};
